module.exports = __webpack_public_path__ + "img/yin.3f41c931.png";